import React from "react";
import classnames from "classnames";
import { AvGroup } from "availity-reactstrap-validation";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { t } from "i18next";

interface Props {
    isConsult: boolean;
    i18nextLng: string;
    selectedLanguage: any;
    advancedDisplayName: any;
    setAdvancedDisplayName: (val: any) => void;
    advancedDisplayNameDefault: any;
    saleSupportLabel: string;
    setDisplayName: (v: string) => void;
    setIsEdited: (v: boolean) => void;
    inputDisplayName: boolean;
    setInputDisplayName: (v: boolean) => void;
    isAdvancedDisplayNameModalOpen: boolean;
    setIsAdvancedDisplayNameModalOpen: (v: boolean) => void;
}

const DisplayNameField: React.FC<Props> = ({
    isConsult,
    i18nextLng,
    selectedLanguage,
    advancedDisplayName,
    setAdvancedDisplayName,
    advancedDisplayNameDefault,
    saleSupportLabel,
    setDisplayName,
    setIsEdited,
    inputDisplayName,
    setInputDisplayName,
    isAdvancedDisplayNameModalOpen,
    setIsAdvancedDisplayNameModalOpen,
}) => {
    const currentValue = advancedDisplayName.languages[i18nextLng] ?? "";

    return (
        <AvGroup>
            <div className="d-flex justify-content-between mb-1">
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Display name")}
                </StyledLabel>
                <span
                    role="button"
                    tabIndex={0}
                    style={{
                        color: "blue",
                        cursor: "pointer",
                        textDecoration: "underline",
                        font: "normal normal 600 16px/21px Segoe UI",
                        marginTop: "15px",
                    }}
                    onClick={() =>
                        setIsAdvancedDisplayNameModalOpen(
                            !isAdvancedDisplayNameModalOpen
                        )
                    }
                    className={classnames("cmn_btn_advencedDisplayName", {
                        "not-allowed-icon__clz":
                            advancedDisplayName.languages[i18nextLng] === "" &&
                            saleSupportLabel === "",
                    })}
                >
                    {t("Advanced")}
                </span>
            </div>

            <StyledTextInput
                className={classnames("sdv_inp_FRdisplayName", {
                    "pe-none__clz": isConsult,
                    input__clz:
                        inputDisplayName ||
                        (currentValue.trim() === "" && currentValue !== ""),
                })}
                autoComplete="off"
                name="DisplayName"
                onChange={(e: any) => {
                    const value = e.target.value.trim();

                    if (saleSupportLabel === "" && value === "") {
                        setAdvancedDisplayName(advancedDisplayNameDefault);
                    } else {
                        setAdvancedDisplayName({
                            ...advancedDisplayName,
                            languages: {
                                ...advancedDisplayName.languages,
                                [selectedLanguage.value]: value,
                            },
                        });
                    }

                    setDisplayName(value);
                    setIsEdited(true);
                    setInputDisplayName(false);
                }}
                value={currentValue}
                placeholder={t("Write")}
                type="text"
            />

            {(inputDisplayName ||
                (currentValue.trim() === "" && currentValue !== "")) && (
                <div className="text-danger small mt-1">
                    {t("Please enter a display name")}
                </div>
            )}
        </AvGroup>
    );
};

export default DisplayNameField;
